import { URL_OFFER_PROPOSAL_ARCHIVE, URL_OFFER_PROPOSAL_UPDATE, URL_XHR_PROPOSAL_SEND_EMAIL } from '@tools/routes/routes';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { Requests } from '@tools/requests';
import { Logger } from '@tools/logger/logger';
import { trans } from '@elements/translation.ts';

export const apiArchiveProposal = async (proposalId: number): Promise<boolean> => {
  try {
    await Requests.patch(URL_OFFER_PROPOSAL_ARCHIVE.replace('{id}', String(proposalId)));
    return true;
  } catch (error) {
    flashBagError();
    Logger.error(error);
  }

  return false;
};

interface UpdateProposalParams {
  comment: string,
}

export const apiUpdateProposal = async (
  proposalId: number,
  params: UpdateProposalParams,
): Promise<boolean> => {
  try {
    await Requests.patch(
      URL_OFFER_PROPOSAL_UPDATE.replace('{id}', String(proposalId)),
      JSON.stringify(params),
    );

    return true;
  } catch (error) {
    Logger.error(error);
  }

  return false;
};

export const apiSendEmailWithLastProposal = async (): Promise<void> => {
  try {
    await Requests.post(URL_XHR_PROPOSAL_SEND_EMAIL);
    flashBagSuccess(trans('selection_item.send_email.flashbag_success'));
  } catch (error) {
    flashBagError();
  }
};
